import { authService } from '../services/authService'
import { useAuthStore } from '../stores/authStore'
import { mapUserResponseToAuthUser } from './performLogin'
import { setAuthToken } from './authStorage'
import { isStandaloneDisplay } from './displayMode'

export function redirectForRole(role: string) {
  if (role === 'admin') window.location.href = '/admin/dashboard'
  else if (role === 'tutor') window.location.href = '/tutor/profile'
  else if (role === 'school') window.location.href = '/school/dashboard'
  else if (role === 'affiliate') window.location.href = '/affiliate'
  else window.location.href = '/messages'
}

export async function completeGoogleSignIn(accessToken: string, rememberMe = true) {
  setAuthToken(accessToken, rememberMe || isStandaloneDisplay())
  const userData = await authService.getCurrentUser()
  const mapped = mapUserResponseToAuthUser(userData)
  useAuthStore.getState().login(mapped)
  return mapped
}
